export const COMPETING_CAMPAIGNS_PAGE_SIZE = 100;
export const COMPETING_CAMPAIGNS_FIRST_PAGE = 1;
export const COMPETING_CAMPAIGNS_MAX_PAGES = 5;
export const COMPETING_CAMPAIGNS_MAX_CHECKED =
  COMPETING_CAMPAIGNS_PAGE_SIZE * COMPETING_CAMPAIGNS_MAX_PAGES;
